import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/UBO');

export default function PEPHint() {
  return <Content />;
}
